var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: "20",
        height: "20",
        viewBox: "0 0 48 48",
      },
    },
    [
      _c("path", {
        attrs: {
          fill: "#cfd8dc",
          d: "M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#448aff",
          d: "M41,24c0,9.391-7.609,17-17,17S7,33.391,7,24S14.609,7,24,7S41,14.609,41,24z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#ff3d00",
          d: "M21.898,21.898l4.203,4.203l9.199-13.402L21.898,21.898z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#bf360c",
          d: "M24,24l11.301-11.301l-9.199,13.402L24,24z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#fff",
          d: "M21.898,21.898l-9.199,13.402l13.402-9.199L21.898,21.898z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#bdbdbd",
          d: "M24,24L12.699,35.301l13.402-9.199L24,24z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#bbdefb",
          d: "M17.102,10.699c0.598-0.301,1.199-0.598,1.797-0.801l1.203,2.703l-1.801,0.797L17.102,10.699z M36,25h2.898c0-0.301,0.102-0.699,0.102-1s0-0.699-0.102-1H36V25z M12.699,14.102l2.102,2.098l1.398-1.398l-2.098-2.102C13.602,13.199,13.199,13.602,12.699,14.102z M25,9.102C24.699,9,24.301,9,24,9s-0.699,0-1,0.102V12h2V9.102z M30.398,10.5c-0.598-0.301-1.199-0.5-1.898-0.699l-1.102,2.801l1.902,0.699L30.398,10.5z M12.5,20.5l0.699-1.898L10.5,17.5c-0.301,0.602-0.5,1.199-0.699,1.898L12.5,20.5z M12,23H9.102C9,23.301,9,23.699,9,24s0,0.699,0.102,1H12V23z M35.5,27.5l-0.699,1.898L37.5,30.5c0.301-0.602,0.5-1.199,0.699-1.898L35.5,27.5z M38.102,18.898c-0.203-0.598-0.5-1.199-0.801-1.797l-2.699,1.199l0.797,1.801L38.102,18.898z M35.301,33.898l-2.102-2.098l-1.398,1.398l2.098,2.102C34.398,34.801,34.801,34.398,35.301,33.898z M13.398,29.699l-0.797-1.801l-2.703,1.203c0.203,0.598,0.5,1.199,0.801,1.797L13.398,29.699z M29.699,34.602l-1.801,0.797l1.203,2.703c0.598-0.203,1.199-0.5,1.797-0.801L29.699,34.602z M20.5,35.5l-1.898-0.699L17.5,37.5c0.602,0.301,1.199,0.5,1.898,0.699L20.5,35.5z M25,38.898V36h-2v2.898c0.301,0,0.699,0.102,1,0.102S24.699,39,25,38.898z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }